<template>
  <div>
    <DataTable
      :title="title"
      :column_names="column_names"
      :columns="column_definitions"
      :total_data_from_parent="total_data"
      :resource_url_from_parent="resource_url"
      :form_name_from_parent="form_name"
      :modal_name_from_parent="modal_name"
      :resource_filter_from_parent="resource_filter"
      :export_file_name_from_parent="export_file_name"
    />
  </div>
</template>

<script>
import $ from "jquery";
import DataTable from "./BaseTable.vue";
import moment from "moment";
// import $ from "jquery";

export default {
  components: {
    DataTable,
  },
  pageLength: 1000,
  data: function () {
    return {
      title: "Lịch sử",
      column_names: ["Thời gian", "User", "Nội dung", "Giá trị cũ", "Giá trị mới"],
      column_definitions: [
        { data: "time",
         render: function(data){return moment(data).format("HH:MM:SS DD/MM/YYYY");}},
        { data: "user" },
        { data: "message" },
        { data: "old_value" },
        { data: "new_value" },
      ],
      total_data: [],
      resource_url: process.env.VUE_APP_API_ENDPOINT + "/api/v1/history",
      resource_filter: {},
      modal_name: "modal-customer-form",
      export_file_name: "history_" + moment().format("DD_MM_YYYY"),
    };
  },
  mounted(){
  $(":contains('Thêm Mới')").closest('button').hide();
}
};
</script>
